export default class Zone
{
    constructor() {
      this.name = ''
      this.size = 0
      this.assets = []
      this.type_id = ''
      this.site_id = ''
    }
}